import { render } from "./VehicleOnOrder.vue?vue&type=template&id=a675bd18"
import script from "./VehicleOnOrder.vue?vue&type=script&lang=js"
export * from "./VehicleOnOrder.vue?vue&type=script&lang=js"

import "./VehicleOnOrder.vue?vue&type=style&index=0&id=a675bd18&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__